import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IEditBrandingPayload {
    brandingId: string
    data: {
        logoImage: string
        bgImage: string
        bgPattern: string
        colorCode: string
        paletteColor: string
        logoColor: string
    }
    sagaCB?: {
        onSuccess: any
    }
}

export interface IEditBrandingState {
    status: string
    data: any
    errors: any
}

const initialState: IEditBrandingState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const editBranding = createSlice({
    name: 'branding/edit',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IEditBrandingPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const editBrandingActions = editBranding.actions
export default editBranding.reducer
